import React, { useState } from 'react';
import ListWithShowMoreLess from '../../common/ListWithShowMoreLess';
//import {TrashIcon} from '../../../../../img/findcare/FindCareSVG';
import './viewempandinsurer.scss';

const ViewEmpAndInsurerPanel = ({ data = [], showLable = 'Employers' }) => {
  const [showMoreItems, setShowMoreItems] = useState(false);

  const RenderEmpAndInsurerListItem = ({ data, index }) => {
    const empAndInsurer = data;
    return (
      <div className="selected-item">
        <div className="d-flex selected-card">
          <div className="flex-1">
            <div>
              <span className="selected-name">{empAndInsurer}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  //return (
  //data ? data.map((item, index) =>
  //<div key={index}>
  //<div className="selected-item">
  //<div className="d-flex selected-card">
  //<div className="flex-1">
  //<div><span className="selected-name">{item}</span></div>
  //</div>
  //</div>
  //</div>
  //</div>
  //) : null
  //)
  return data?.length > 0 ? (
    <ListWithShowMoreLess
      data={data}
      RenderItemComponent={RenderEmpAndInsurerListItem}
      showMore={showMoreItems}
      setShowMore={setShowMoreItems}
      showMoreLabel={showLable}
    />
  ) : null;
};

export default ViewEmpAndInsurerPanel;
